import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SessionStorage, SessionStorageService } from "ngx-webstorage";
import { SiniestralidadMaternidad, MaternidadEntity } from '../../entities/vam_entities';
import { forEach } from '@angular/router/src/utils/collection';


@Component({
    selector: 'DetalleMaternidad',
    templateUrl: 'maternidad.template.html'
})

export class MaternidadComponent implements OnChanges, OnInit {
    ListadoMaternidades: MaternidadEntity[];
    NumRclTitulares: number;
    NumRclDependientes: number;
    TotalMaternidades: number;

    @Input('siniestralidadMaternidades')
    detalleMaternidades: SiniestralidadMaternidad;

    constructor() {
        this.detalleMaternidades = new SiniestralidadMaternidad();
        this.ListadoMaternidades = [];
        this.NumRclTitulares = 0;
        this.NumRclDependientes = 0;


    }
    ngOnInit(): void {
        this.detalleMaternidades = new SiniestralidadMaternidad();
        this.ListadoMaternidades = [];
        this.NumRclTitulares = 0;
        this.NumRclDependientes = 0;

    }

    ngOnChanges(): void {
        if (this.detalleMaternidades != null) {
            this.ListadoMaternidades = this.detalleMaternidades.Maternidades;
            var banNombreTit = "";
            var banBene = "";
            var tit = 0;
            var bene = 1;
            if (this.ListadoMaternidades != undefined && this.ListadoMaternidades != null) {
                this.ListadoMaternidades.forEach(item => {
                    {
                        if (item.NombresTitular != null && banNombreTit.trim() != item.NombresTitular.trim()) {
                            banNombreTit = item.NombresTitular;
                            banBene = item.Beneficiario;
                            tit++;
                            bene = 1;
                            item.Beneficiario = "Beneficiario " + bene;
                        }
                        else {
                            if (item.Beneficiario != null && banBene.trim() == item.Beneficiario.trim()) {
                                banBene = item.Beneficiario;
                                item.Beneficiario = "Beneficiario " + bene;
                            }
                            else {
                                bene++;
                                banBene = item.Beneficiario;
                                item.Beneficiario = "Beneficiario " + bene;
                            }
                        }
                        item.NombresTitular = "Usuario " + tit;
                    }
                });
            }
            /*let banMatTit: string = "";
            let ban: number = 0;
            if (this.ListadoMaternidades != undefined && this.ListadoMaternidades != null) {
                this.ListadoMaternidades.forEach(a => {
                    if (a.NombresTitular !== banMatTit) {
                        ban++;
                    }
                    a.NombresTitular = "Usuario " + ban;
                });
            }*/
            this.NumRclTitulares = this.detalleMaternidades.NumTitularesMaternidad;
            this.NumRclDependientes = this.detalleMaternidades.NumDepenMaternidad;
            this.TotalMaternidades = this.detalleMaternidades.TotalMaternidades;

        }

    }

}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/siniestralidad/maternidad.component.ts